import NL_TRANSLATIONS from "./nl.json";

const TRANSLATIONS = {
  nl: NL_TRANSLATIONS,
};

export const LANGUAGE = "nl";

/**
 * Resolve the translation
 *
 * @param {string | Array<string>} key_or_keys - The key to translate, or an array of keys
 * @param {Record<string, string>} interpolations - Values to be filled in the translation
 * @param {string} fallback - A fallback value if the output is undefined
 * @param {string} language - The language to translate to
 * @returns string
 */
export default function translate(
  key_or_keys,
  interpolations = {},
  fallback = null,
  language = LANGUAGE,
) {
  const keys = Array.isArray(key_or_keys)
    ? key_or_keys
    : key_or_keys.split(".");
  let translation = keys.reduce((scope, key) => {
    if (scope) return scope[key];
  }, TRANSLATIONS[language]);

  if (typeof translation === "string") {
    Object.entries(interpolations).forEach(
      ([key, value]) =>
        (translation = translation.replaceAll(`{{${key}}}`, value)),
    );
  } else if (translation === undefined && fallback !== null) {
    return fallback;
  } else {
    // This should only happen during development
    // eslint-disable-next-line no-console
    console.error(`Translation ${keys.join(".")} could not be found`);
  }

  return translation;
}
